import {
  SET_OPENID,
  SET_APPLICANTNAME,
  SET_APPLICANTIDNUMBER,
  SET_APPLICANTMOBILE,
  SET_APPLICANTEMAIL,
  SET_RECOGNIZEENAME,
  SET_RECOGNIZEEIDNUMBER,
  SET_RECOGNIZEEMOBILE,
  SET_RECOGNIZEEEMAIL,
  SET_ISSHOWINSURED,
  SET_VIN,
  SET_ENGINENO,
  SET_BRANDMODEL,
  SET_DEBUTDATE,
  SET_ISCHANGENAME,
  SET_TRANSFERDATE,
  SET_ISLOAN,
  SET_LENDERS,
  SET_OWNERNAME,
  SET_OWNERIDNUMBER,
  SET_OWNERMOBILE,
  SET_VEHICLEDTOOBJ,
  SET_VEHICLEOWNEROBJ,
  SET_ISINITIALSTATE,
  SET_QUOTATIONOBJ,
} from '@/constants/action-type';

const INITIAL_STATE = {
  openId: '',
  aplicantName: '',
  applicantIdNumber: '',
  applicantMobile: '',
  applicantEmail: '',
  recognizeeName: '',
  recognizeeIdNumber: '',
  recognizeeMobile: '',
  recognizeeEmail: '',
  isShowInsured: true,
  vin: '',
  engineNo: '',
  brandModel: '',
  debutDate: '',
  isChangeName: '',  
  transferDate: '',
  isLoan: '',
  lenders: '',
  ownerName: '',
  ownerIdnumber: '',
  ownerMobile: '',
  vehicleDTOObj: {},
  vehicleOwnerObj: {},
  isInitialState: true,
  quotationObj: {},
}

export function globalReducer(state=INITIAL_STATE, action:any) {
  switch (action.type) {
    case SET_OPENID:
      return {
        ...state,
        openId:action.payload
      }
    case SET_APPLICANTNAME:
    case SET_APPLICANTIDNUMBER:
    case SET_APPLICANTMOBILE:
    case SET_APPLICANTEMAIL:
    case SET_RECOGNIZEENAME:
    case SET_RECOGNIZEEIDNUMBER:
    case SET_RECOGNIZEEMOBILE:
    case SET_RECOGNIZEEEMAIL:
    case SET_ISSHOWINSURED:
    case SET_VIN:
    case SET_ENGINENO:
    case SET_BRANDMODEL:
    case SET_DEBUTDATE:
    case SET_ISCHANGENAME:
    case SET_TRANSFERDATE:
    case SET_ISLOAN:
    case SET_LENDERS:
    case SET_OWNERNAME:
    case SET_OWNERIDNUMBER:
    case SET_OWNERMOBILE:
    case SET_VEHICLEDTOOBJ:
    case SET_VEHICLEOWNEROBJ:
    case SET_ISINITIALSTATE:
    case SET_QUOTATIONOBJ:
      return {
        ...state,
        ...action.payload,
      }
    default:
      return state
  }
}